import { Component } from 'react'
import { func, node } from 'prop-types'

class ErrorBoundary extends Component {
  static propTypes = {
    onError: func.isRequired,
    children: node.isRequired
  }

  componentDidCatch(error, info) {
    this.props.onError(error)

    if (!window.Sentry) return

    window.Sentry.withScope(scope => {
      scope.setExtras(info)
      window.Sentry.captureException(error)
    })
  }

  render() {
    return this.props.children
  }
}

export default ErrorBoundary
